import { i18n } from "@/shared/i18n"
import { isObject } from "@/shared/lib"

import type { FetchBaseQueryError } from "@reduxjs/toolkit/query"

export const SETTINGS_EXPORT_DM_UNAVAILABLE_ERROR_CODE = "settings_export_dm_unavailable"

const getErrorCode = (error: FetchBaseQueryError): string | null => {
  if (!isObject(error.data)) return null

  const errors: unknown = error.data.error
  if (!Array.isArray(errors)) return null

  const firstError: unknown = errors.at(0)
  if (!isObject(firstError) || typeof firstError.code !== "string") return null

  return firstError.code
}

export const toExportGroupSettingsError = (error: FetchBaseQueryError): FetchBaseQueryError => {
  if (getErrorCode(error) !== SETTINGS_EXPORT_DM_UNAVAILABLE_ERROR_CODE) return error

  return {
    status: "CUSTOM_ERROR",
    error: i18n.t("export-private-chat-required", "Open a private chat with the bot before exporting settings")
  }
}
